<div class="second-screen-header">
    <img class="theme-logo-content" />
    @for (crumb of breadcrumbs; track crumb) {
    <h2 class="second-screen-header-breadcrumb">
        {{ crumb.value }}
    </h2>
    }
</div>

@for (slide of slides; track slide) {
<div class="second-screen-slide-row">
    <div class="second-screen-slide-title">
        <h2>{{ slide.getName() }}</h2>
    </div>
    <div class="second-screen-slide">
        <app-screen
            class="second-screen-slide__screen"
            [teacherMode]="true"
            [resource]="slide"
            [autoload]="true"
        ></app-screen>
    </div>
</div>
}
